import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateContactHero(section, hr, textLines, items, buttons) {

  // Inidividual tweens
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr tween 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    ease: "power1.out",
  }) : null;

  // Contact info items 
  let itemsTween = items ? gsap.to(items, {
    duration: 0.5,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .addLabel("textStart")
    .add(textLinesTween, "textStart")
    .add(hrTween, "textStart-=0.2")
    .add(itemsTween, "-=0.4")
    .add(buttonsTween, "-=0.5");
}